export const organisationListAction = list => ({
  type: 'ORGANISATION_LIST',
  list,
})

export const editOrganisationAction = edit => ({
  type: 'ORGANISATION_EDIT',
  edit,
})
